import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './index.scss';

class Contacts extends Component {
  render() {
    const { title, contacts } = this.props;

    const contactElements = contacts.map((contact) => {
      return (
        <div key={contact.sys.id} className={styles.contact}>
          <div className={styles.name}>
            {contact.fields.name}
          </div>
          {( contact.fields.phone &&
            <div className={styles.phone}>
              {contact.fields.phone}
            </div>
          )}
          {( contact.fields.mobilePhone &&
            <div className={styles.phone}>
              {contact.fields.mobilePhone}
            </div>
          )}
          {( contact.fields.email &&
            <div className={styles.mail}>
              <a href={`mailto:${contact.fields.name}<${contact.fields.email}>?subject=Anfrage über die Website`}>{contact.fields.email}</a>
            </div>
          )}
        </div>
      );
    });

    return (
      <section className={styles.wrapper}>
        <h3>{title}</h3>
        <div className={styles.contacts}>
          {contactElements}
        </div>
      </section>
    );
  }
}

Contacts.propTypes = {
  title: PropTypes.string.isRequired,
  contacts: PropTypes.array.isRequired
}

export default Contacts;



// WEBPACK FOOTER //
// ./src/components/contacts/index.jsx